export const defaultMetaData = {
  storeName: 'My Store',
  logo: {
    src: '/logo192.png',
    alt: 'Store Logo'
  },
  imageCdn: 'https://dnzp6dhrl0ccw.cloudfront.net/public/e4d85458-4001-70f6-dd07-74aaad858060/default',
  menuItems: [
    { text: 'Home', icon: 'HomeIcon', path: '/' },
    { text: 'Products', icon: 'Inventory2Icon', path: '/products' },
    { text: 'Collections', icon: 'CollectionsIcon', path: '/collections' },
    { text: 'Settings', icon: 'SettingsIcon', path: '/settings' }
  ],
  texts: {
    homePage: {
      title: 'Welcome to Our Store',
      subtitle: 'Discover amazing products at great prices',
      shopNowButton: 'Shop Now'
    },
    contact: {
      title: 'Contact Us',
      description: 'Get in touch with our team'
    }
  },
  theme: {
    mode: 'light', // light or dark
    primaryColor: '#1976d2',
    secondaryColor: '#dc004e'
  },
  seo: {
    defaultTitle: 'My Store',
    description: 'Amazing products at great prices',
    keywords: ['store', 'products', 'shopping']
  },
  search: {
    view: 'grid', // grid, large, compact
    sortBy: 'featured',
  },
  menuConfig: [
    { type: 'normal', title: 'All Products', url: '/search' },
    { type: 'collections', title: 'Collections', collapsed: false },
    { type: 'brands', title: 'Brands', collapsed: false },
  ],
  collections: [
    {
      criteria: '',
      title: 'All Products',
      subtitle: 'Complete product catalog',
      description: 'Explore our entire collection of products. Find everything you need in one place, from everyday essentials to specialty items.'
    },
    {
      criteria: 'brand:*',
      title: '{brand}',
      subtitle: '{brand} products',
      description: 'Shop the complete {brand} collection. Discover authentic {brand} products with guaranteed quality and style.'
    },
    {
      criteria: 'collection:*',
      title: '{collection}',
      subtitle: '{collection} collection',
      description: 'Browse our curated {collection} selection. Handpicked items that embody the essence and style of {collection}.'
    },
    {
      criteria: 'brand:*,collection:*',
      title: '{brand} — {collection}',
      subtitle: '{brand} {collection} products',
      description: 'Explore {brand}\'s {collection} line. Premium {brand} products from the {collection} collection, combining brand heritage with curated style.'
    },
  ],
};
